module.exports = __webpack_public_path__ + "static/media/downloadLock.b32e1859.svg";